import layout from "./layout"
import navbar from "./navbar"
import authentication from "./authentication"
import fetchParams from "./fetchParams"

const rootReducer = {
  navbar, layout, authentication, fetchParams
}

export default rootReducer
